import { Component } from '@angular/core';
import { Platform, App, AlertController, ToastController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AngularFireAuth } from 'angularfire2/auth';
import { Globals } from "../globals";
import { SuperPage } from "../pages/auth/super/super";
import { HomePage } from "../pages/home/home";
import { AuthServices } from "../pages/auth/services";
import { MultiPage } from '../pages/auth/multi/multi';
import { ProvidersServices } from '../pages/providers/services';
import { HomePrincipalPage } from '../pages/schools/home-principal/home-principal';
import { HomeTeacherPage } from '../pages/schools/home-teacher/home-teacher';
import { ScreenOrientation } from '@ionic-native/screen-orientation';
import { BackgroundMode } from '@ionic-native/background-mode';
import { TranslateService } from '@ngx-translate/core';
import { Network } from '@ionic-native/network';
import { NativeStorage } from '@ionic-native/native-storage';
import { LoginPreviewPage } from '../pages/auth/login-preview/login-preview';
import { Device } from '@ionic-native/device';
import { PrintServices } from '../pages/services/printServices';
import { TakeawayServices } from '../pages/takeaway/services';
import { Push, PushObject, PushOptions } from '@ionic-native/push';
import * as firebase from 'firebase';
import { NotificationsServices } from '../pages/services/notificationsServices';
import { Deeplinks } from '@ionic-native/deeplinks';
import { MenuListPage } from './../pages/menu/menu-list/menu-list';
import { DishListPage } from './../pages/dish/dish-list/dish-list';
import { TutorialTpvPage } from '../pages/help/tutorials/tutorial-tpv/tutorial-tpv';
import { CartasMenusListPage } from '../pages/cartas-menus/cartas-menus-list/cartas-menus-list';
import { ReservationLoaderPage } from '../pages/reservation/reservation-loader/reservation-loader';
import { TutorialReservasPage } from '../pages/help/tutorials/tutorial-reservas/tutorial-reservas';
import { SetupInital2Page } from '../pages/setup/setup-initial-2/setup-inital-2';
import { SetupPage } from '../pages/setup/setup-initial/setup';
import { OdsViewPage } from '../pages/ods/ods-view/ods-view';
import { TutorialPedidosPage } from '../pages/help/tutorials/tutorial-pedidos/tutorial-pedidos';
import { StockListPage } from '../pages/stock/stock-list/stock-list';
import { ConfigurationServices } from '../pages/configuration/services';
import { ArticlesListPage } from '../pages/articles/articles-list/articles-list';
import { ConfigurationRoomsPage } from '../pages/configuration/configuration-rooms/configuration-rooms';
import { TpvPanelPage } from '../pages/tpv/tpv-panel/tpv-panel';

@Component({
  templateUrl: 'app.html'
})

export class MyApp {
  rootPage: any;
  firestore: any;

  constructor(platform: Platform,
    statusBar: StatusBar,
    public splashScreen: SplashScreen,
    public afAuth: AngularFireAuth,
    public globals: Globals,
    private authServices: AuthServices,
    private providersServices: ProvidersServices,
    public plt: Platform,
    private screenOrientation: ScreenOrientation,
    public alertCtrl: AlertController,
    public app: App,
    private backgroundMode: BackgroundMode,
    public translate: TranslateService,
    private network: Network,
    private nativeStorage: NativeStorage,
    private device: Device,
    public printServices: PrintServices,
    public takeawayServices: TakeawayServices,
    private push: Push,
    public notificationsServices: NotificationsServices,
    private deeplinks: Deeplinks,
    public toastCtrl: ToastController,
    public configurationServices: ConfigurationServices) {


    platform.ready().then(() => {
      splashScreen.show();
      
      try {
        this.firestore = firebase.firestore();
      } catch (error) {
        console.error('Firebase initialization error:', error);
      }
      
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      try {
        this.backgroundMode.enable();
      } catch (error) {
        console.error('Background mode error:', error);
      }
      
      //lang
      this.translate.setDefaultLang('es');
      this.translate.use(this.globals.returnLangBrowser(this.translate.getBrowserLang()));
      
      //get device info
      this.globals.device_model = this.device.model;
      this.globals.device_manufacturer = this.device.manufacturer;
      
      //Detect system
      if (this.plt.is('android') || this.plt.is('ios')) {
        this.globals.so_mobile = true;
        //Detect SO
        if (this.plt.is('android')) {
          this.globals.android = true
          this.globals.so_name = 'android';
        }
        if (this.plt.is('ios')) {
          this.globals.ios = true
          this.globals.so_name = 'ios';
        }
      }
      
      //Detect platform is mobile and close options
      if (this.plt.is('mobile') || this.plt.is('iphone')) {
        this.globals.platform_mobile = true;
        this.globals.platform_name = 'mobile';
        try {
          this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);
        } catch (error) {
          console.error('Screen orientation error:', error);
        }
      }
      
      //Detect tablet - Landscape
      if (this.plt.is('tablet') || this.plt.is('ipad')) {
        this.globals.platform_mobile = false;
        this.globals.platform_name = 'tablet';
        try {
          this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE_PRIMARY);
        } catch (error) {
          console.error('Screen orientation error:', error);
        }
      }
      
      //Detect browser name
      this.globals.browser_name = this.globals.getBrowserName();
      
      //Detect dimensions
      var platform_width = this.plt.width();
      if (platform_width < 600) {
        this.globals.platform_width = 'mobile';
      } else if (platform_width >= 600 && platform_width < 1025) {
        this.globals.platform_width = 'tablet';
      } else if (platform_width >= 1025) {
        this.globals.platform_width = 'desktop';
      }
      
      // Get user data and go to the next page
      try {
        this.afAuth.authState.subscribe(userAuth => {
          if (userAuth) {
            if (this.globals.restaurant_uid != '') {
              this.getUserData(userAuth.uid, userAuth.email);
            } else {
              // Usuario autenticado pero sin restaurant_uid
              this.rootPage = LoginPreviewPage;
              this.splashScreen.hide();
            }
          } else {
            //this.checkDeepLinks(false);
            this.rootPage = LoginPreviewPage;
            this.splashScreen.hide();
          }
        });
      } catch (error) {
        console.error('Auth state error:', error);
        this.rootPage = LoginPreviewPage;
        this.splashScreen.hide();
      }

      statusBar.styleDefault();
    });
    //mirem back button
    platform.registerBackButtonAction(() => {
      // Catches the active view
      let nav = this.app.getActiveNavs()[0];
      let activeView = nav.getActive();
      // Checks if can go back before show up the alert
      if (activeView.component.name === 'HomePage') {
        if (nav.canGoBack()) {
          nav.pop();
        } else {
          const alert = this.alertCtrl.create({
            title: this.translate.instant('instant-salir-mycheftool'),
            message: this.translate.instant('instant-seguro-quieres-salir-mycheftool'),
            buttons: [{
              text: this.translate.instant('general-cancelar'),
              role: 'cancel',
              handler: () => {

              }
            }, {
              text: this.translate.instant('general-salir'),
              handler: () => {
                platform.exitApp();
              }
            }]
          });
          alert.present();
        }
      } else {
        if (nav.canGoBack()) {
          nav.pop();
        }
      }
    });
  }

  async getUserData(user_uid, user_email) {
    //GET ALL DATA (updateUserGlobals)
    await this.authServices.updateUserGlobals(user_uid, user_email);
    if (this.globals.user_type != 'principal' && this.globals.user_type != 'teacher') {
      //GET TOTAL CART ELEMENTS
      this.providersServices.getTotalCartElements(this.globals.restaurant_uid, this.globals.user_uid);
      //GET ALL DATA (updateUserGlobals)
      await this.globals.getRestaurant(this.globals.restaurant_uid);
      //GET NO PROVIDER
      this.globals.getNoProvider();
      //set lang app
      this.globals.setTranslate();
      //detect currency lang
      this.globals.currency_lang = this.globals.checkCurrencyLang(this.globals.restaurant.lang);
      //
      this.checkNetwork();
      //update uid_restaurant to push_token
      this.pushSetup(user_uid);
      //recuperamos los usuarios
      this.globals.getUsersFromNode();
      //udpdate hubspot contact once day
      this.checkUpdateERPNextCustomer();
      //check if restaurant not has customer id to create
      await this.checkUserNotHasStripeCustomerId();
      //Login GA
      this.globals.GAtrackView('Login', 'Login', this.globals.restaurant.email, 'Login', 'Login', 'Login', '');
      //caso impresora local sunmi
      if (this.globals.device_manufacturer == 'SUNMI') {
        this.printServices.configLocalSunmiPrinter();
      }
    } else {
      await this.globals.getSchool(this.globals.school_uid);
    }
    //get Deliveries
    this.takeawayServices.getDeliveries();
    this.configurationServices.recoveryDeliveriesFavorites();
    //
    this.checkDeepLinks(true);
    //IF USER TYPE
    if (this.globals.user_type === 'indv') {
      //inv usuario con 1 restaurante
      this.splashScreen.hide();
      //Si el restaurante no ha completado alguno de los setup
      if (this.globals.restaurant.register_step == 'setup1' || this.globals.restaurant.register_step == undefined) {
        this.rootPage = SetupPage;
      } else if (this.globals.restaurant.register_step == 'setup2') {
        this.rootPage = SetupInital2Page;
      } else {
        this.rootPage = HomePage;
        this.globals.side_menu_active = 'dashboard';
      };
    } else if (this.globals.user_type === 'super') {
      //super - page list super restaurants
      this.splashScreen.hide();
      this.rootPage = SuperPage
    } else if (this.globals.user_type === 'multi') {
      //multi - page list to the user restaurants
      this.splashScreen.hide();
      this.rootPage = MultiPage;
    } else if (this.globals.user_type === 'principal') {
      //principal - page list to the user restaurants
      this.splashScreen.hide();
      this.rootPage = HomePrincipalPage;
    } else if (this.globals.user_type === 'teacher') {
      //principal - page list to the user restaurants
      this.splashScreen.hide();
      this.rootPage = HomeTeacherPage;
    } else {
      //Usuarios creados sin ningun restaurante
      this.splashScreen.hide();
      this.rootPage = LoginPreviewPage;
    }
  }

  //check network
  checkNetwork() {
    //disconnectSubscription
    this.network.onDisconnect().subscribe(() => {
      this.globals.connection = false;
      this.globals.connection_manual = true;
      this.nativeStorage.getItem('offline_number')
        .then(
          data => { },
          error => {
            //no tiene crear
            this.nativeStorage.setItem('offline_number', 0)
              .then(() => { }, error => { });
          }
        );

    });
    
    //connectSubscription
    this.network.onConnect().subscribe(() => {
      this.globals.connection = true;
      this.globals.connection_manual = false;
    });
  }

  //
  async pushSetup(uid_auth) {
    //que notificaciones push solo funcione con android | ios
    if (this.globals.platform_name != 'core') {
      //init options de notificaciones push
      const options: PushOptions = {
        android: {
          senderID: '934198322702',
        },
        ios: {
          alert: 'true',
          badge: true,
          sound: 'true'
        },
        browser: {
        }
      };
      //iniciamos pushObject para detectar todas funciones que nos ofrece
      const pushObject: PushObject = this.push.init(options);
      //solo en caso ios tiene alert de pedir permisos en caso android se iniciara todo al cumplir condicion de tener permisos
      //miraremos repetidas veces si tenemos permisos mientras se acepte o no el alert. 
      //Para salir tenemos 2 condiciones -> tienes permisos aceptados o se agoten las peticiones
      var count_intents = 0;
      var interval = await setInterval(() => {
        //
        this.push.hasPermission()
          .then((res: any) => {
            count_intents++;
            if (res.isEnabled || count_intents == 6) {
              //We have permission to send push notifications
              clearInterval(interval);
            } else {
              //We do not have permission to send push notifications
            }
          });
      }, 4000);
      //miramos caso para registrar token
      pushObject.on('registration').subscribe((registration: any) => {
        //enviamos token y uid_auth a funcion para guardar
        this.registerToken(registration.registrationId, uid_auth);
        //guardamos el token del usuario actual en una variable
        this.globals.token_current_user = registration.registrationId;
      });
      
      pushObject.on('logout').subscribe((logout: any) => { });
      
      pushObject.on('notification').subscribe((notification: any) => {
        //Received a notification
      });
      
      pushObject.on('error').subscribe(error => {});
    }
    //init manual notifications push
    this.notificationsServices.getNotificationsBadge(uid_auth);
  }

  //funcion que registra el token en la subcollection push_tokens
  async registerToken(_token, _uid_token_user) {
    const data = {
      token: _token,
      uid: _uid_token_user,
      UID_RESTAURANT: this.globals.restaurant_uid,
    };
    //recuperamos el usuario
    await this.firestore.collection('users').where('uid_user_auth', '==', _uid_token_user).get()
      .then((snapshot) => {
        snapshot.forEach(async (doc) => {
          this.globals.token_user_uid = doc.id;
          //guardamos el token pasando el uid doc del usuario
          this.saveToken(doc.id, data);
        });
      })
  }

  //funcion que guarda el token depende de situaciones
  async saveToken(uid_user, data) {
    await this.firestore.collection('users').doc(uid_user).collection('push_tokens').get()
      .then(async doc => {
        var exist = false;
        //miramos si hay algun documento en la subcollection
        if (doc.size > 0) {
          //hi ha coleccio push_tokens creada
          //recuperamos los tokens de la subcollection
          const user_tokens = await this.firestore.collection('users').doc(uid_user).collection('push_tokens');
          user_tokens.get()
            .then(snapshot => {
              snapshot.forEach(doc_tok => {
                //miramos si el token ya esta registrado
                if (data.token == doc_tok.data().token) {
                  exist = true;
                }
              });
              //en caso existe
              if (!exist) {
                user_tokens.add(data);
              }
            });
        } else {
          //guardamos el token a la subcollection
          this.firestore.collection('users').doc(uid_user).collection('push_tokens').add(data);
        }
      });
  }

  //
  async checkDeepLinks(auth) {
    this.deeplinks.route({
      '/': HomePage,
      '/pay-stripe-pro-month': HomePage,
      '/pay-stripe-pro-year': HomePage,
      '/pay-stripe-business-month': HomePage,
      '/pay-stripe-business-year': HomePage,
      '/pay-stripe-basic-month': HomePage,
      '/pay-stripe-basic-year': HomePage,
      '/pay-paypal-pro-month': HomePage,
      '/pay-paypal-pro-year': HomePage,
      '/pay-paypal-business-month': HomePage,
      '/pay-paypal-business-year': HomePage,
      '/pay-paypal-basic-year': HomePage,
      '/articles': DishListPage,
      '/cartas-menus': CartasMenusListPage,
      '/pos': TutorialTpvPage,
      '/reservas': ReservationLoaderPage,
      '/delivery': OdsViewPage,
      '/stock': StockListPage,
      '/config-rooms': StockListPage,
    }).subscribe(async (match) => {
      // match.$route - the route we matched, which is the matched entry from the arguments to route()
      // match.$args - the args passed in the link
      // match.$link - the full link data
      //check auth true to checkout pay
      if (auth) {
        var path = match.$link.path.split("-");
        if (path[0] !== '/' && path[0] !== '/articles' && path[0] !== '/menus' && path[0] !== '/pos' && path[0] !== '/cartas' && path[0] !== '/reservas' && path[0] !== '/delivery' && path[0] !== '/config' && path[0] !== '/stock') {//que no este en  home
          if (this.globals.restaurant.license !== path[2]) {
            //enviar a api para pagar
            var final_path = this.globals.api_path + "suscription/" + this.globals.user_email + "/" + path[1] + "/" + path[2] + "/" + path[3];
            window.open(final_path, '_self');
          } else {
            let toast = this.toastCtrl.create({
              message: 'Ya tienes la licencia, te redirigiremos al dashboard en breves.',
              duration: 3000,
              position: 'top'
            });
            toast.present();
            await this.globals.delay(3000);
            window.open("https://app2.mycheftool.com/", '_self');
          }
        } else if (path[0] === '/articles') {
          let nav = this.app.getActiveNavs()[0];
          this.globals.side_menu_active = 'dish';
          nav.push(ArticlesListPage);
        } else if (path[0] === '/menus') {
          let nav = this.app.getActiveNavs()[0];
          this.globals.side_menu_active = 'menu';
          nav.push(MenuListPage);
        } else if (path[0] === '/cartas') {
          let nav = this.app.getActiveNavs()[0];
          this.globals.side_menu_active = 'carta';
          nav.push(CartasMenusListPage);
        } else if (path[0] === '/pos') {
          let nav = this.app.getActiveNavs()[0];
          this.globals.side_menu_active = 'tpv';
          nav.push(TpvPanelPage, {
            origin: 'tpv'
          });
        } else if (path[0] === '/reservas') {
          let nav = this.app.getActiveNavs()[0];
          if (this.globals.checkLimitsByLicense('reservations', 'calendar')) {
            this.globals.side_menu_active = 'reservation';
            nav.push(ReservationLoaderPage);
          } else {
            this.globals.side_menu_active = 'reservation';
            nav.push(TutorialReservasPage);
          }
        } else if (path[0] === '/delivery') {
          let nav = this.app.getActiveNavs()[0];
          if (this.globals.checkLimitsByLicense('sites', 'sites')) {
            this.globals.side_menu_active = 'web';
            nav.push(OdsViewPage);
          } else {
            this.globals.side_menu_active = 'web';
            nav.push(TutorialPedidosPage);
          }
        } else if (path[0] === '/stock') {
          let nav = this.app.getActiveNavs()[0];
          this.globals.side_menu_active = 'stock';
          nav.push(StockListPage);
        } else if (path[0] === '/config' && path[1] === 'rooms') {
          let nav = this.app.getActiveNavs()[0];
          this.globals.side_menu_active = 'config';
          nav.push(ConfigurationRoomsPage);
        }
      }
    });
  }

  //check if update erpnext customer
  checkUpdateERPNextCustomer() {
    try {
      //prepare dates
      var last_date = this.globals.restaurant.erpnext_last_update_customer ? this.globals.restaurant.erpnext_last_update_customer.toDate() : null;
      var today = new Date();
      // Compara las fechas
      if (last_date == null || (last_date.getFullYear() !== today.getFullYear() || last_date.getMonth() !== today.getMonth() || last_date.getDate() !== today.getDate())) {
        //update restaurant
        this.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
          erpnext_last_update_customer: new Date()
        });
        //send api hubspot update contact
        this.globals.updateERPNextCustomer();
      }
    } catch (error) { }
  }

  async checkUserNotHasStripeCustomerId() {
    if (this.globals.restaurant.stripe_customer_id == undefined || this.globals.restaurant.stripe_customer_id == '') {//no tiene crear
      //create stripe customer id
      var customer = await this.globals.createStripeCustomer();
      if (customer['customer_id']) {
        await this.firestore.collection('restaurants').doc(this.globals.restaurant_uid).update({
          stripe_customer_id: customer['customer_id']
        }).then(() => {
          this.globals.restaurant.stripe_customer_id = customer['customer_id'];
        });
      }
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts